import React from 'react'
import { Link } from 'react-router-dom'
const AiMlSection1 = () => {
    return (
        <>
            <div className="container">
            <div className="text-center px-20">
                <div className="section-heading">
                    <div className="title-wrapper">
                        <h2 className="section-title has_fade_anim fs-4x  text-grad-1 pb-6">
                            AI/ML Services
                        </h2>
                    </div>
                    <div className="text-wrapper mt-0">
                        <p className="text has_fade_anim mt-3 fs-1  text-grad-3">
                            15+ Years Experience in A-Z of AI, ML and Data Science
                        </p>
                    </div>
                    <div className="btn-wrap has_fade_anim mt-10">
                        <Link to="#artificial-intelligence" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Artificial Intelligence">Artificial Intelligence</span>
                        </Link>
                        <Link to="#machine-learning" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 me-5 fs-4">
                            <span data-text="Machine Learning">Machine Learning
                            </span>
                        </Link>
                        <Link to="#domain-expertise" className="wc-btn wc-btn-primary bordered btn-text-flip p-5 fs-4 me-5">
                            <span data-text="Domain Expertise">Domain Expertise
                            </span>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
        </>
    )
}

export default AiMlSection1